/* unplugin-vue-components disabled */import script from "./AIPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AIPage.vue?vue&type=script&setup=true&lang=js"

import "./AIPage.vue?vue&type=style&index=0&id=09263429&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09263429"]])

export default __exports__